import { render, staticRenderFns } from "./restFacilitiesLayout.vue?vue&type=template&id=179d0be9"
import script from "./restFacilitiesLayout.vue?vue&type=script&lang=js"
export * from "./restFacilitiesLayout.vue?vue&type=script&lang=js"
import style0 from "./restFacilitiesLayout.vue?vue&type=style&index=0&id=179d0be9&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179d0be9')) {
      api.createRecord('179d0be9', component.options)
    } else {
      api.reload('179d0be9', component.options)
    }
    module.hot.accept("./restFacilitiesLayout.vue?vue&type=template&id=179d0be9", function () {
      api.rerender('179d0be9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/rtf/restFacilitiesLayout.vue"
export default component.exports